module.exports = __webpack_public_path__ + "img/liveBg.1462758f.png";